import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', () => {
    const state = reactive<{
        menu: any[]
        legal: any[]
        categories: any[]
        sizes: any[]
        tresholds: any[]
        strings: []
    }>({
        menu: [],
        legal: [],
        categories: [],
        sizes: [],
        tresholds: [],
        strings: [],
    })

    return {
        state,
    }
})
